import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './Header';
import PhotoSubmissionModal from './PhotoSubmissionModal';

import './HomePage.css';

const HomePage = () => {
  const [playerName, setPlayerName] = useState('');
  const [showError, setShowError] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Focus on input when component mounts
    const input = document.getElementById('playerNameInput');
    if (input) {
      input.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!playerName.trim()) {
      setShowError(true);
      return;
    }

    // Store player name in localStorage for the session
    localStorage.setItem('currentUser', playerName.trim());
    
    // Navigate to the game
    navigate('/game');
  };

  const handleInputChange = (e) => {
    setPlayerName(e.target.value);
    if (showError) {
      setShowError(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const handlePhotoSubmissions = () => {
    setShowPhotoModal(true);
  };



  return (
    <div className="home-page">
      <Helmet>
        <title>🎮 NicoleCodeGirl Memory Game - Test Your Memory Skills!</title>
        <meta name="description" content="Play the NicoleCodeGirl Memory Game! Match cards featuring photos from Nicole's life and compete for the best times on the leaderboard." />
        
        {/* Open Graph */}
        <meta property="og:title" content="🎮 NicoleCodeGirl Memory Game - Test Your Memory Skills!" />
        <meta property="og:description" content="Play the NicoleCodeGirl Memory Game! Match cards featuring photos from Nicole's life and compete for the best times on the leaderboard." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content="https://memory-game.nicolecodegirl.com/photos/nicoleLogo2.png" />
        <meta property="og:site_name" content="NicoleCodeGirl" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="🎮 NicoleCodeGirl Memory Game - Test Your Memory Skills!" />
        <meta name="twitter:description" content="Play the NicoleCodeGirl Memory Game! Match cards featuring photos from Nicole's life and compete for the best times on the leaderboard." />
        <meta name="twitter:image" content="https://memory-game.nicolecodegirl.com/photos/nicoleLogo2.png" />
      </Helmet>
      <Header 
        title="NicoleCodeGirl Memory Game"
        showLeaderboard={false}
        showNewPlayer={false}
        onPhotoSubmissions={handlePhotoSubmissions}
      />

      <div className="players-wrapper">
        <div className="enter-name-wrapper">
          <div className="enter-name-body">
            <h1 className="enter-name-h1">Enter Your Name To Play</h1>
            
            <form className="enter-name-form" onSubmit={handleSubmit}>
              <input
                type="text"
                id="playerNameInput"
                className="player-name-input"
                value={playerName}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                placeholder="Enter your name here..."
                maxLength="20"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                data-lpignore="true"
                data-form-type="other"
                required
              />
              
              {showError && (
                <p className="name-required">Please enter your name to start playing!</p>
              )}
              
              <div className="enter-name-buttons">
                <button 
                  type="submit" 
                  className="start-game-btn"
                  aria-label="Start Game"
                >
                  Start Game
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <PhotoSubmissionModal 
        isOpen={showPhotoModal}
        onClose={() => setShowPhotoModal(false)}
      />

    </div>
  );
};

export default HomePage; 